/* Catering cart hygiene (2026-09-25)
 * 1. One catering order per cart: on direct buffet product pages (window.SC_ESTIMATE),
 *    adding to cart while another catering order is already in the cart asks the customer
 *    to replace it; existing catering lines are removed first. Non-catering items are kept.
 * 2. Removes the retired $80 "Standard Buffet Set-up" line (CAT-SETUP-STD) from every cart.
 *    Stations-only orders no longer carry it either (25 Sep 2026): the 10% service charge replaces it.
 */
(function () {
  'use strict';
  var DIRECT = ['fsu-dim-sum-catering-lite','fsu-catering-menu-classic','fsu-dim-sum-catering-premium',
    'happy-catering-set-a','happy-catering-set-b','the-grand-christmas-feast'];
  function isCatering(i) {
    var sku = i.sku || '';
    return sku.indexOf('CAT-') === 0 || i.vendor === 'Swee Choon Catering v2' ||
      i.product_type === 'Avis-add-charge' || i.product_type === 'mws_fee_generated' ||
      DIRECT.indexOf(i.handle) !== -1;
  }
  var realFetch = window.fetch.bind(window);
  function getCart() { return realFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function removeKeys(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    window.__CATERING_CART_CLEAR_APPROVED = true;
    return window.fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }) })
      .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); })
      .finally(function () { window.__CATERING_CART_CLEAR_APPROVED = false; });
  }

  /* ---------- 2. stale setup cleanup (all pages) ---------- */
  function cleanStaleSetup() {
    return getCart().then(function (c) {
      var items = c.items || [];
      var stale = items.filter(function (i) { return i.sku === 'CAT-SETUP-STD' || i.handle === 'c-setup-standard'; }).map(function (i) { return i.key; });
      if (!stale.length) return false;
      return removeKeys(stale).then(function () {
        if (/^\/cart\/?$/.test(location.pathname)) location.reload();
        return true;
      });
    }).catch(function () { return false; });
  }

  /* ---------- 1. one catering order per cart (direct buffet pages) ---------- */
  var passUntil = 0, pending = null;
  function guardAdd() {
    if (Date.now() < passUntil) return Promise.resolve(true);
    if (pending) return pending;
    pending = getCart().then(function (c) {
      var lines = (c.items || []).filter(isCatering);
      if (!lines.length) { passUntil = Date.now() + 20000; return true; }
      var amt = lines.reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0) / 100;
      var ok = window.confirm('Your cart already has a catering order (S$' + amt.toFixed(2) + ').\n\n' +
        'Only one catering order can be checked out at a time, so delivery and charges are not doubled.\n\n' +
        'Press OK to REPLACE it with this order, or Cancel to keep your current cart.');
      if (!ok) return false;
      return removeKeys(lines.map(function (i) { return i.key; })).then(function () {
        passUntil = Date.now() + 20000; return true;
      });
    }).finally(function () { setTimeout(function () { pending = null; }, 0); });
    return pending;
  }
  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/i.test(u || ''); }

  if (window.SC_ESTIMATE) {
    var prevFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var self = this, args = arguments;
      if (!isAddUrl(url)) return prevFetch.apply(self, args);
      return guardAdd().then(function (ok) {
        if (!ok) return Promise.reject(new Error('Kept existing catering order'));
        return prevFetch.apply(self, args);
      });
    };
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__schUrl = u; return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this, args = arguments;
      if (!isAddUrl(xhr.__schUrl)) return xSend.apply(xhr, args);
      guardAdd().then(function (ok) { if (ok) xSend.apply(xhr, args); else try { xhr.abort(); } catch (e) {} });
    };
    // Native (non-ajax) form submits
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || !isAddUrl(f.getAttribute('action')) || f.__schOk) return;
      e.preventDefault(); e.stopImmediatePropagation();
      guardAdd().then(function (ok) { if (ok) { f.__schOk = true; HTMLFormElement.prototype.submit.call(f); } });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanStaleSetup);
  else cleanStaleSetup();
})();
